/**
 * Copy text to the clipboard with progressive fallbacks.
 * Returns true if the text was copied (or selected), false if the user has to copy by hand.
 *
 * Tries in order:
 *   1) navigator.clipboard.writeText (modern, requires permission)
 *   2) document.execCommand('copy') via a temporary textarea (legacy, works in iframes)
 *   3) shows a prompt() with the text pre-selected so the user can copy manually
 */
export async function copyText(text) {
  if (!text) return false;
  // 1) Modern API — may throw NotAllowedError inside iframes with restrictive Permissions-Policy.
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* fall through */
    }
  }
  // 2) Legacy textarea + execCommand('copy').
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    if (ok) return true;
  } catch {
    /* fall through */
  }
  // 3) Last resort — let the user copy by hand from a prompt.
  try {
    window.prompt("Copy the text below — press long-press → Copy, then Cancel.", text);
  } catch {
    /* ignore */
  }
  return false;
}
